import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {investorUpdateKpiTypeConst} from '../core/_constants'

export const KpiComponent = ({
  data,
  index,
  handleToogle,
  deleteKpi,
}: {
  data: any
  index: number
  handleToogle: (id: number, what: string, checked: boolean | string, index: number) => void
  deleteKpi: (id: number, index: number) => void
}) => {
  const {
    id,
    toogle,
    title,
    value,
    type,
  }: {id: number; toogle: boolean; title: string; value: string; type: string} = data

  return (
    <form className='kpi-input form-check form-check-custom form-check-solid form-check-primary form-switch gap-5 kpiForm mb-3'>
      <img src={toAbsoluteUrl('/media/icons/investor/hamburger.svg')} alt='hamburger' />
      <input
        className='form-check-input'
        type='checkbox'
        name='model.app.sidebar.default.minimize.desktop.hoverable'
        id={id.toString()}
        checked={toogle}
        onChange={(e) => {
          handleToogle(id, 'toogle', e.target.checked, index)
        }}
      />
      <input
        className={`form-control h-40px font-size-12 kpiInput`}
        type='text'
        id={id.toString()}
        defaultValue={title}
        onChange={(e) => {
          handleToogle(id, 'title', e.target.value, index)
        }}
      />
      <input
        className={`form-control h-40px font-size-12 kpiInput w-250px`}
        type='number'
        id={id.toString()}
        defaultValue={value}
        onChange={(e) => {
          handleToogle(id, 'value', e.target.value, index)
        }}
      />
      <select
        className={`form-select form-select-lg h-36px font-size-13 ${
          !type && 'kpiSelect'
        }  w-175px`}
        placeholder='select type'
        id={id.toString()}
        value={type}
        onChange={(e) => {
          handleToogle(id, 'type', e.target.value, index)
        }}
      >
        {investorUpdateKpiTypeConst.map((kpiType) => (
          <option key={kpiType.id} value={kpiType.value}>
            {kpiType.name}
          </option>
        ))}
      </select>
      <img
        src={toAbsoluteUrl('/media/icons/investor-updates/deleteRed.svg')}
        alt='delete'
        id={id.toString()}
        height='20px'
        width='20px'
        className='kpiImg cursor-pointer'
        onClick={() => {
          deleteKpi(id, index)
        }}
      />
    </form>
  )
}
